import { render, staticRenderFns } from "./AllDocs.vue?vue&type=template&id=2c00686a&scoped=true"
import script from "./AllDocs.vue?vue&type=script&lang=js"
export * from "./AllDocs.vue?vue&type=script&lang=js"
import style0 from "./AllDocs.vue?vue&type=style&index=0&id=2c00686a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c00686a",
  null
  
)

export default component.exports